var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 8.23878,
    y: 13.1743,
    width: 102.498,
    height: 85.415
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.69px)",
      clipPath: "url(#bgblur_0_9884_4467_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 11.3887,
    x: 19.6274,
    y: 24.563,
    width: 79.7206,
    height: 62.6376,
    rx: 17.083,
    fill: "url(#paint0_linear_9884_4467)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2339,
    y: 42.1252,
    width: 79.375,
    height: 61.875,
    rx: 15.625,
    fill: "url(#paint1_linear_9884_4467)",
    stroke: "white",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9884_4467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9919 60C68.646 60.2224 70.2984 60.4345 71.8728 61.0414C75.0874 62.281 77.6934 64.2793 79.6371 67.1172C79.826 67.3948 79.989 67.6914 80.2387 68.1017C78.6592 68.0983 77.2079 68.1017 75.7757 68.4362C74.3123 68.7793 72.9617 69.5517 71.2919 69.0431C70.236 68.7207 68.998 69.0241 67.845 68.9672C67.1688 68.9345 66.9937 69.1776 67.037 69.8017C67.0856 70.4879 66.9486 71.1966 67.0648 71.8655C67.5173 74.4724 66.0504 76.6034 65.3985 79.0034C65.3621 78.8966 65.3378 78.8586 65.3378 78.8207C65.3638 76.9466 65.3638 76.9466 63.5242 76.9466C61.7921 76.9466 60.0582 76.9672 58.326 76.9345C57.7521 76.9241 57.5527 77.0948 57.629 77.6672C57.8787 79.5448 58.5393 81.2672 59.5085 82.8879C59.7114 83.2259 59.9958 83.231 60.32 83.2293C61.7643 83.2241 63.2086 83.2414 64.6512 83.219C65.1003 83.2121 65.3448 83.3276 65.4176 83.8017C65.884 86.8345 67.3058 89.3655 69.5165 91.481C69.5754 91.5379 69.6101 91.619 69.6933 91.7466C68.5958 92.15 67.4722 92.119 66.3712 92.1517C58.2463 92.3862 51.0542 86.131 50.1491 78.0741C50.1214 77.8534 50.0503 77.6345 50 77.4138C50 76.5517 50 75.6897 50 74.8276C50.0503 74.6086 50.1196 74.3914 50.1456 74.1707C50.9588 67.4552 55.8501 62.0052 62.4596 60.4845C63.3803 60.2724 64.3252 60.1586 65.2581 60C65.8354 60 66.4146 60 66.9919 60ZM61.4453 75.2707C62.5411 75.2707 63.6369 75.2586 64.7327 75.2759C65.1575 75.2828 65.3604 75.169 65.3552 74.6983C65.3344 72.9776 65.3361 71.2569 65.3534 69.5362C65.3586 69.0603 65.1419 68.9707 64.7223 68.9776C63.3092 68.9966 61.8961 68.9931 60.483 68.9793C60.131 68.9759 59.9021 69.0707 59.7097 69.3845C58.7127 71.0172 58.0192 72.7586 57.6689 74.6379C57.5753 75.1448 57.7469 75.2931 58.2446 75.2793C59.3109 75.2517 60.3772 75.2707 61.4453 75.2707ZM57.9411 68.9845C56.535 68.9845 55.2987 68.9948 54.0625 68.9776C53.7174 68.9724 53.551 69.1259 53.4001 69.4069C52.5072 71.069 52.0044 72.8448 51.7824 74.7086C51.7339 75.1259 51.8691 75.2793 52.287 75.2741C53.3238 75.2586 54.3607 75.2707 55.3993 75.2672C55.6264 75.2655 55.8553 75.281 55.8969 74.9431C56.15 72.8776 56.8505 70.9552 57.9411 68.9845ZM53.9532 76.9483C53.3256 76.9483 52.8054 76.9655 52.287 76.9431C51.857 76.9241 51.7356 77.1 51.7842 77.5086C52.0044 79.3448 52.4985 81.0948 53.355 82.7448C53.5614 83.1431 53.8267 83.25 54.2462 83.2379C55.1392 83.2121 56.0356 83.2103 56.9285 83.2379C57.5025 83.2552 57.7417 83.1931 57.3863 82.5569C56.7396 81.4 56.3581 80.1362 56.0651 78.8483C55.9281 78.2431 56.1379 77.4362 55.694 77.0672C55.2484 76.6931 54.4751 77 53.9532 76.9483ZM54.782 67.2586C55.3785 67.2586 55.7617 67.2052 56.1223 67.2672C58.1665 67.6241 59.6455 66.9638 60.7673 65.1586C61.5094 63.9655 62.6833 63.0655 63.6802 62.0397C60.1137 62.65 57.2042 64.3397 54.782 67.2586ZM77.6032 67.2569C75.1966 64.3431 72.3045 62.6517 68.7483 62.05C70.3522 63.6276 71.8849 65.2517 73.2027 67.0621C73.3206 67.2241 73.4783 67.2552 73.6552 67.2552C74.9088 67.2586 76.1641 67.2569 77.6032 67.2569ZM54.7733 84.9431C57.1661 87.8241 59.9854 89.5103 63.4618 90.1207C61.8562 88.5483 60.261 86.9862 58.9554 85.1621C58.8462 85.0103 58.6988 84.9414 58.5133 84.9414C57.336 84.9448 56.1622 84.9431 54.7733 84.9431ZM65.343 89.3121C65.343 87.8586 65.343 86.6328 65.343 85.4086C65.343 85.1534 65.2823 84.9483 64.972 84.9483C63.6976 84.9465 62.4232 84.9483 60.9789 84.9483C62.3035 86.6241 63.6681 87.9517 65.343 89.3121ZM65.343 62.9776C63.7721 64.3379 62.4856 65.6759 61.2129 67.2586C62.5515 67.2586 63.701 67.2534 64.8506 67.2621C65.1506 67.2638 65.35 67.2 65.3465 66.8448C65.3378 65.619 65.343 64.3948 65.343 62.9776ZM71.1914 67.2569C69.8771 65.6552 68.6166 64.3138 67.0492 62.9983C67.0492 64.3914 67.0526 65.5862 67.0457 66.7793C67.044 67.0862 67.1324 67.2621 67.4826 67.2603C68.6547 67.2517 69.8268 67.2569 71.1914 67.2569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7057 95C88.4989 93.6845 87.2696 92.3897 86.0993 91.0448C85.6849 90.5672 85.3918 90.5207 84.8179 90.8207C78.8864 93.9345 71.7203 90.8 70.0298 84.3828C68.5404 78.7293 72.0965 73.1104 77.9709 71.8293C83.4655 70.6328 89.0833 74.4069 90.082 79.9535C90.5085 82.3276 90.1773 84.5793 89.0156 86.6948C88.792 87.1017 88.7469 87.3655 89.1058 87.7362C90.4253 89.1017 91.7049 90.5052 93.0001 91.8948C93.0001 91.9517 93.0001 92.0104 93.0001 92.0672C91.9598 93.0448 90.9194 94.0207 89.8791 94.9983C89.8219 95 89.7629 95 89.7057 95ZM71.3059 81.8035C71.2955 86.5431 75.1447 90.4414 79.8764 90.4828C84.6775 90.5259 88.6585 86.6604 88.6723 81.9414C88.6879 77.0707 84.8734 73.2207 80.0134 73.1966C75.2054 73.1741 71.3146 77.019 71.3059 81.8035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9884_4467_clip_path",
    transform: "translate(-8.23878 -13.1743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.6274,
    y: 24.563,
    width: 79.7206,
    height: 62.6376,
    rx: 17.083
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9884_4467",
    x1: 42.6238,
    y1: 38.265,
    x2: 105.778,
    y2: 66.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F4690"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9884_4467",
    x1: 69.9214,
    y1: 41.5002,
    x2: 69.9214,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9884_4467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 35,
    fill: "white",
    transform: "translate(50 60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.275fc385a4db188569755d63e8521e0f.svg";
export { ForwardRef as ReactComponent };